export const apiBaseUrlSSO = "https://api.simulanis.io";
export const applicationId = "188230d3-3f6d-4648-9a0a-0fc7a68db55c";
export const redirectUrl = "https://apps.simulanis.io";
export const defaultLogo = "https://simulanis.blob.core.windows.net/sso/logos/default_simulanis.png"
